// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BarsOutlinedSvg from "@fishx/icons-svg/es/asn/BarsOutlined";
import FishxIcon from '../components/FishxIcon';

var BarsOutlined = function BarsOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BarsOutlinedSvg
  }));
};

BarsOutlined.displayName = 'BarsOutlined';
export default React.forwardRef(BarsOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BarsOutlined.js
// module id = 2062
// module chunks = 0